import type { CoreRootState } from './CoreStore';
import { Predicator } from './Predicator';

export const CorePredicator = new Predicator<CoreRootState>();
